import { Component } from 'react';
import withAuth from '../../components/withAuth';
import {compose} from "redux";
import {connect} from "react-redux";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import {searchAnalyseRisques } from '../../redux/analyseRisques/analyseRisquesEditionActions';
import { fillPartialSpp, redirect } from '../../redux/analyseRisques/analyseRisquesActions';
import {throwErrorMessage} from '../../lib/error_helper'
import {getAllStatus} from '../../redux/analyseRisques/analyseRisquesStatusActions'
import '../../utils.css';
import SelectWithModal from '../../components/SelectWithModal/SelectWithModal'
import Typography from '@mui/material/Typography';
import SearchTable from '../../components/AnalyseRisques/SearchTable'
import CustomizedTextField from '../../components/Input/CustomizedTextField';

class SearchTab extends Component {

    constructor(props){
        super(props);

        this.props.fillPartialSpp([]);

        this.state = {
            searchCustomerInput: "",
            searchAnalyseRisqueInput: "",
            searchAffairInput: "",
            searchWorkOrderInput: "",
            agency: "",
            status: "",
            moduleSpp: "",
        }
    }

    static getDerivedStateFromProps (nextProps, prevState){
        if(nextProps.redirectUrl !== null){
            nextProps.history.push(nextProps.redirectUrl);
            nextProps.resetRedirect();
        }

        return prevState;
    }

    handleSearchClick(e){
        e.preventDefault();

        let searchInput = this.state.searchAnalyseRisqueInput;
        let customerInput = this.state.searchCustomerInput;
        let affairInput = this.state.searchAffairInput;
        let workOrderInput = this.state.searchWorkOrderInput;
        let agencySelection = this.state.agency;
        let statusSelection = this.state.status;
        let moduleSpp = this.props.analysesRisques.moduleSpp;

        if(!searchInput && !customerInput && !affairInput && !workOrderInput &&
             !agencySelection && !statusSelection){

            this.props.throwErrorMessage("Veuillez sélectionner au moins un filtre");
            return;
        }

        this.props.searchAnalyseRisques(searchInput, customerInput, affairInput,
            workOrderInput, agencySelection, statusSelection, moduleSpp);
    }

    searchAnalyseRisqueInput(e){
        this.setState({searchAnalyseRisqueInput: e.target.value});
    }

    searchCustomerInput(e){
        this.setState({searchCustomerInput: e.target.value});
    }

    searchAffairInput(e){
        this.setState({searchAffairInput: e.target.value})
    }

    searchWorkOrderInput(e){
        this.setState({searchWorkOrderInput: e.target.value})
    }

    onAgencyChange(value){
        this.setState({agency: value});
    }

    onStatusChange(value){
        this.setState({status: value});
    }

    render() {
        let typeText = "d'analyses de risques"

        if(this.props.moduleSpp)
            typeText = "de plans de prévention simplifiés"

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin">
                    <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                        <Typography component="p" >
                            {"Recherche " + typeText + " dans OpenERP afin de les visualiser ou de les continuer"}
                        </Typography>
                        <div className="row div-center">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
                                <CustomizedTextField id="search-input"
                                    label="Code AR/PPS"
                                    className="textField full_size"
                                    value={this.state.searchAnalyseRisqueInput}
                                    onChange={this.searchAnalyseRisqueInput.bind(this)}/>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
                                <CustomizedTextField id="customer-input"
                                    label="Client"
                                    className="textField full_size"
                                    value={this.state.searchCustomerInput}
                                    onChange={this.searchCustomerInput.bind(this)}/>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
                                <CustomizedTextField id="affair-input"
                                    label="Affaire"
                                    className="textField full_size"
                                    value={this.state.searchAffairInput}
                                    onChange={this.searchAffairInput.bind(this)}/>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
                                <CustomizedTextField id="ot-input"
                                    label="Ordre de travail"
                                    className="textField full_size"
                                    value={this.state.searchWorkOrderInput}
                                    onChange={this.searchWorkOrderInput.bind(this)}/>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top without-side-padding">
                                <SelectWithModal
                                    label={"Agence"}
                                    onValidate={this.onAgencyChange.bind(this)}
                                    isClearable
                                    value={this.state.agency}
                                    name="agency"
                                    className="full_size"
                                    classNamePrefix="select"
                                    options={this.props.companies.map((c) => {
                                        return {
                                            value: c.id,
                                            label: c.name
                                        }
                                    })}
                                />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top without-side-padding">
                                <SelectWithModal
                                    label={"Statut"}
                                    onValidate={this.onStatusChange.bind(this)}
                                    isClearable
                                    value={this.state.status}
                                    name="status"
                                    className="full_size"
                                    classNamePrefix="select"
                                    options={getAllStatus().filter((s) => s.spp === this.props.moduleSpp).map((c) => {
                                        return {
                                            value: c.id,
                                            label: c.label
                                        }
                                    })}
                                />
                            </div>
                            <div className="offset-lg-9 col-lg-3 offset-md-8 col-md-4 offset-sm-6 col-sm-6 offset-7 col-5 control-margin-top">
                                <Fab variant="extended" onClick={this.handleSearchClick.bind(this)} type="button" color="primary">
                                    <Icon>search</Icon>
                                    Rechercher
                                </Fab>
                            </div>
                        </div>
                    </CardContent>
                </Card>
                <SearchTable />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        analysesRisques: state.analysesRisques,
        partialSpp: state.analysesRisques.partialSpp,
        moduleSpp: state.analysesRisques.moduleSpp,
        companies: state.companies.companies,
        redirectUrl: state.analyseRisques.redirectUrl,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchAnalyseRisques: (searchInput, searchCustomerInput, searchAffairInput, searchWorkOrderInput, agency, status, moduleSpp) => dispatch(searchAnalyseRisques(searchInput, searchCustomerInput, searchAffairInput, searchWorkOrderInput, agency, status, moduleSpp)),
        throwErrorMessage: (message) => dispatch(throwErrorMessage({
            errorObject: null,
            title: "Erreur",
            message: message,
        })),
        resetRedirect: () => dispatch(redirect(null)),
        fillPartialSpp: (list) => dispatch(fillPartialSpp(list)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(SearchTab);
